module.exports = __webpack_public_path__ + "static/media/beenext-logo.30126989.jpg";